import config from 'config';
import { authHeader, loggedInUser } from '@mobile/services/user';
import axios from '@mobile/util/axios';
import onDownloadProgress from '@mobile/util/onDownloadProgress';
import { eventBus } from '@/eventBus';
import Vue from 'vue';

async function send(inspection) {
    const request = {
        headers: authHeader(),
        data: inspection,
        onUploadProgress(progressEvent) {
            if (progressEvent.total > 0) {
                if (progressEvent.loaded === progressEvent.total) {
                    eventBus.$emit('uploadDone');
                } else {
                    eventBus.$emit('uploadProgress', {
                        message: window.i18n.t('Uploading inspection...'),
                        total: progressEvent.total,
                        done: progressEvent.loaded,
                    });
                }
            }
        },
    };

    request.method = inspection.inspection_id ? 'put' : 'post';
    request.url = `${config.apiUrl}/${config.apiVersion}/inspections${inspection.inspection_id
        ? `/${inspection.inspection_id}`
        : ''}`;

    debugger;
    const sendRequest = await axios(request);
    Vue.gtm.trackEvent({
        event: 'inspectionConducted',
    });
    eventBus.$emit('uploadDone');
    if (sendRequest && [200, 201].includes(sendRequest.status)) {
        return sendRequest.data;
    }
}

function get(inspectionId, withProgress = false) {
    return axios.get(
        `${config.apiUrl}/${config.apiVersion}/inspections/${inspectionId}`,
        { headers: authHeader(), onDownloadProgress: withProgress ? onDownloadProgress : null },
    )
        .then(({ data }) => {
            if (data.form.params.format_version !== config.jsonFormatVersion) {
                return Promise.reject({
                    message: window.i18n.t('Incompatible form version: {formVersion} instead of {systemVersion}', {
                        formVersion: data.form.params.format_version,
                        systemVersion: config.jsonFormatVersion,
                    })
                });
            }

            return Promise.resolve(data);
        });
}

async function getFilterOptions() {
    const response = await axios.get(
        `${config.apiUrl}/${config.apiVersion}/inspections/filters`,
        { headers: authHeader() },
    );

    if (response && response.status === 200) {
        return response.data;
    }
}

async function getPDFURL(inspectionId) {
    const response = await axios.get(
        `${config.apiUrl}/${config.apiVersion}/authenticate/download`,
        {
            headers: authHeader(),
        },
    );

    if (response && response.status === 200) {
        const { timezone } = loggedInUser();
        const { token } = response.data;
        return `${config.apiUrl}/${config.apiVersion}/inspections/${inspectionId}.pdf?token=${token}&timezone=${timezone}`;
    }
}

async function getAll(url, filters = {}, withProgress = false) {
    if (!url) {
        url = `${config.apiUrl}/${config.apiVersion}/inspections`;
    }

    const filtersToSend = JSON.parse(JSON.stringify(filters));
    console.log(JSON.stringify(filters));

    const response = await axios.get(
        url,
        {
            headers: authHeader(),
            params: filtersToSend,
            onDownloadProgress: withProgress ? onDownloadProgress : null,
        },
    );

    if (response && response.status === 200) {
        return response.data;
    }
}

export default {
    send,
    get,
    getAll,
    getPDFURL,
    getFilterOptions,
};
